import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { APP_NAME } from '../models/app-info.model';

const TITLE_SEPARATOR = ' · ';

@Injectable()
export class AppTitleStrategyService extends TitleStrategy {
  //* Services
  private readonly _title = inject(Title);

  //* Public Methods
  public override updateTitle(snapshot: RouterStateSnapshot): void {
    const pageTitle = this.buildTitle(snapshot);
    this._title.setTitle(pageTitle ? `${pageTitle}${TITLE_SEPARATOR}${APP_NAME}` : APP_NAME);
  }
}
